export const DRIVER_NOTIFICATION_EVENT = "sedulur-dalan:notify";

export const DRIVER_NOTIFICATION_PRIORITY = Object.freeze({
  success: 20,
  info: 40,
  warning: 60,
  error: 80,
});

export function notifyDriver(message, options = {}) {
  const text = String(message || "").trim();
  if (!text || typeof window === "undefined") return;

  const tone = ["success", "error", "warning", "info"].includes(options.tone) ? options.tone : "info";
  const requestedPriority = Number(options.priority);
  const priority = Number.isFinite(requestedPriority)
    ? Math.max(0, Math.min(100, requestedPriority))
    : DRIVER_NOTIFICATION_PRIORITY[tone];

  window.dispatchEvent(new CustomEvent(DRIVER_NOTIFICATION_EVENT, {
    detail: {
      id: options.id || globalThis.crypto?.randomUUID?.() || `driver-notice-${Date.now()}-${Math.random().toString(16).slice(2)}`,
      message: text,
      title: String(options.title || "").trim() || null,
      tone,
      priority,
      createdAt: Date.now(),
      duration: Number.isFinite(Number(options.duration)) ? Math.max(1800, Number(options.duration)) : 5000,
      persistent: Boolean(options.persistent),
      compact: Boolean(options.compact),
      dismissible: options.dismissible !== false,
      icon: String(options.icon || "").trim() || null,
    },
  }));
}